import React from 'react';
import './Templates.css';

export interface MotivationalTemplateData {
  title?: string;
  quote?: string;
  backgroundImage?: string;
  backgroundColor?: string;
  hashtags?: string[];
  logoUrl?: string;
}

interface MotivationalTemplateProps {
  data: MotivationalTemplateData;
  className?: string;
}

export const MotivationalTemplate: React.FC<MotivationalTemplateProps> = ({ data, className = '' }) => {
  const {
    title = 'Motivação',
    quote = 'Sua jornada começa hoje!',
    backgroundImage,
    backgroundColor = '#667eea',
    hashtags = [],
    logoUrl,
  } = data;

  return (
    <div 
      className={`motivational-template ${className}`} 
      id="image-generator-template"
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        backgroundColor: !backgroundImage ? backgroundColor : undefined,
      }}
    >
      <div className="template-container motivational-container">
        {/* Overlay para melhorar legibilidade */}
        {backgroundImage && <div className="template-overlay"></div>}

        {/* Content */}
        <div className="motivational-content">
          {title && (
            <h1 className="motivational-title">{title}</h1>
          )}
          
          <div className="motivational-quote">
            <div className="quote-mark">"</div>
            <p className="quote-text">{quote}</p>
            <div className="quote-mark">"</div>
          </div>

          {hashtags && hashtags.length > 0 && (
            <div className="motivational-hashtags">
              {hashtags.map((tag, index) => (
                <span key={index} className="hashtag-item">
                  #{tag.replace('#', '')}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Watermark Logo */}
        {logoUrl && (
          <div className="template-watermark">
            <img src={logoUrl} alt="Logo" className="watermark-logo" />
          </div>
        )}
      </div>
    </div>
  );
};












